import { createClient } from '@supabase/supabase-js'

// Estas credenciais serão substituídas pelo .env em produção
const FALLBACK_URL = 'https://strzusmlmlmlpbzvuwiw.supabase.co'
const FALLBACK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN0cnp1c21sbWxtbHBienZ1d2l3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE5NjYwMzcsImV4cCI6MjA5NzU0MjAzN30.K4XpOSNKG6aOWeL6fEf8O134aksSDCiJzZkEdpJDHqg'

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || FALLBACK_URL
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || FALLBACK_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
